/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import StripeConnection from '/client/src/components/dialogs/stripeConnection';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleToggleModal: (boolean) => void,
  settings: {}
};

class EditPaymentModal extends React.Component<PropsType> {
  props: PropsType;

  handleClose = (): any => {
    const { handleToggleModal } = this.props;

    handleToggleModal(false);
  };

  render(): React.Element<'div'> {
    const { isOpen } = this.props;
    // const { methods } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div className="modal-dialog customModal EditLanguageModal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Profile</h4>
              <span
                style={{
                  position: 'absolute',
                  top: '1.25rem',
                  right: '1.25rem',
                  cursor: 'pointer'
                }}
              >
                <i className="glyphicon glyphicon-remove" onClick={this.handleClose} />
              </span>
            </div>
            <div className="modal-body">
              <StripeConnection
                withoutRequest
                settings={this.props.settings}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditPaymentModal;
